// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8601) return "static/chunks/solana-fae209bcb6f70806.js";
	if (chunkId === 1862) return "static/chunks/mapbox-b02f27dc97bb432c.js";
	if (chunkId === 1624) return "static/chunks/1624-08e98b278f0d143c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"577":"5a10bb5071a2e9dc","6687":"32a0f0bbc37f2eb7","9573":"d2ba37278104a388"}[chunkId] + ".js";
};